import { SORT, SEARCH, RELEASES_STATE, RELEASES_TYPE } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import * as types from 'modules/releases/actionTypes';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'text' | 'releaseStates' | 'releaseTypes' | 'sort'} FilterReleaseField */
/** @typedef {string | number | Array<string> | Array<number>} FilterValue */
/** @typedef {Record<FilterReleaseField, FilterValue>} ReleasesFiltersReducer */

const persistedFilters = getPersistedFilters()?.filters?.releases ?? {};

const emptyState = {
  [SEARCH]: null,
  [RELEASES_STATE]: [],
  [RELEASES_TYPE]: [],
  [SORT]: 'releaseDate,DESC',
};

/** @type {import("modules/global/reducers/filterSliceAdapter").FilterAdapter<ReleasesFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_RELEASES_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.SET_RELEASES_DASHBOARD_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_RELEASES_DASHBOARD_FILTERS]: filterAdapter.resetFilters,
  [types.REMOVE_RELEASES_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
